/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaxDiscount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MaxDiscount({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info/MaxDiscount"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let setupMaxDiscountValueData = fromData.useDataFormat({ viewPath,
context: 'setup',
path: 'max_discount',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="MaxDiscount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Maximum discount possible"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="setup.max_discount"
 format="/Data/format.js numberMoney"
 text={setupMaxDiscountValueData}
/>
</div>
{children}
</React.Fragment>)
}